import React, { useState } from "react";
import { GameSession, PagedResponse } from "./types";
import {
  isoDay, daysAgo, fmtAmt, fmtInt, fmtDate, short, usePaged, useDebounced,
  Header, DateRange, TestToggle, ErrorBox, Panel, Pager, FilterBar, EmptyRow, PlayerCell,
  inputCls, thCls, thR, tdCls, tdR, theadRow, tbodyRow, pageCls,
} from "./shared";

const pickSessions = (d: PagedResponse) => d.sessions;

export default function Sessions() {
  const [userId, setUserId] = useState("");
  const [game, setGame] = useState("");
  const [environment, setEnvironment] = useState("");
  const [from, setFrom] = useState(daysAgo(29));
  const [to, setTo] = useState(isoDay(new Date()));
  const [includeTest, setIncludeTest] = useState(false);
  const dUser = useDebounced(userId);
  const dGame = useDebounced(game);

  const { rows, pagination, setPage, loading, error, load } = usePaged<GameSession>("/sessions", pickSessions, {
    user_id: dUser.trim(), game_code: dGame.trim().toLowerCase(), environment, from, to, include_test: includeTest,
  });

  return (
    <div className={pageCls}>
      <Header title="Original Games — Sessions" subtitle="Game launches and what was played in each session" onRefresh={load} loading={loading} />
      <ErrorBox error={error} />
      <Panel title={<>Sessions <span className="text-sm text-[#878AA2] font-normal ml-2">({fmtInt(pagination.totalCount)} total)</span></>}>
        <FilterBar>
          <input value={userId} onChange={(e) => setUserId(e.target.value.replace(/\D/g, ""))} placeholder="User ID" className={inputCls + " w-32"} />
          <input value={game} onChange={(e) => setGame(e.target.value)} placeholder="Game code" className={inputCls + " w-32"} />
          <select value={environment} onChange={(e) => setEnvironment(e.target.value)} className={inputCls}>
            <option value="">All environments</option>
            <option value="production">production</option>
            <option value="sandbox">sandbox</option>
          </select>
          <DateRange from={from} to={to} setFrom={setFrom} setTo={setTo} />
          <TestToggle value={includeTest} onChange={setIncludeTest} />
        </FilterBar>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className={theadRow}>
              <th className={thCls}>Launched</th><th className={thCls}>Player</th><th className={thCls}>Game</th><th className={thCls}>Currency</th>
              <th className={thCls}>Mode / Env</th><th className={thCls}>Platform</th><th className={thR}>Bets</th>
              <th className={thR}>Wagered</th><th className={thR}>Payout</th><th className={thCls}>Session</th>
            </tr></thead>
            <tbody>
              {rows.map((s) => (
                <tr key={s.id} className={tbodyRow}>
                  <td className={tdCls + " text-[#878AA2]"}>{fmtDate(s.created_at)}</td>
                  <PlayerCell name={s.user_name} id={s.user_id} />
                  <td className={tdCls + " capitalize"}>{s.game_code}</td>
                  <td className={tdCls}>{s.currency}</td>
                  <td className={tdCls}>
                    <span className={s.mode === "real" ? "text-[#0ECC68]" : "text-[#FFC23F]"}>{s.mode}</span>
                    <span className="text-[#878AA2]"> / {s.environment}</span>
                  </td>
                  <td className={tdCls + " text-[#878AA2]"}>{s.platform || "—"}</td>
                  <td className={tdR}>{fmtInt(s.bets)}</td>
                  <td className={tdR + " text-[#4A85F7]"}>{fmtAmt(s.wagered)}</td>
                  <td className={tdR + " text-[#0ECC68]"}>{fmtAmt(s.payout)}</td>
                  <td className={tdCls + " font-mono text-xs text-[#878AA2]"} title={s.session_id}>{short(s.session_id, 13)}</td>
                </tr>
              ))}
              {!loading && rows.length === 0 && <EmptyRow cols={10} text="No sessions match these filters" />}
            </tbody>
          </table>
        </div>
        <Pager p={pagination} onPage={setPage} />
      </Panel>
    </div>
  );
}
